import React, { forwardRef } from 'react';
import { adCard as c } from '../../component-classes';

type AdCardProps = {
    'aria-owns'?: string;
    className?: string;
    children?: React.ReactNode;
    flat?: boolean;
    style?: React.CSSProperties;
};

const AdCard = forwardRef<HTMLElement, AdCardProps>((props, forwardedRef) => {
    const { className = '', children, flat = false, style } = props;

    const cardClass = `${c.card} ${c.cardOutline} ${flat ? '' : c.cardShadow}`;

    return (
        <article
            ref={forwardedRef}
            className={`${cardClass} ${className}`}
            style={style}
        >
            <div aria-owns={props['aria-owns']} className="absolute"></div>
            {children}
        </article>
    );
});

export default AdCard;
